import WithTriangleUiContext from 'Pods/Shared/Hocs/WithTriangleUiContext'
import SubscriptionLabel from 'Pods/Shared/SubscriptionLabel/SubscriptionLabel'

const mapStateToProps = (context) => ({ locale: context?.locale })

export default WithTriangleUiContext(mapStateToProps)(SubscriptionLabel)
